package dev.lingvo.site.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderRight
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onKeyDown
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.breakpointFloor
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import dev.lingvo.shared.Role
import dev.lingvo.shared.WorkResponse
import dev.lingvo.shared.WorkSectionDto
import dev.lingvo.site.api.ApiClient
import dev.lingvo.site.api.Async
import dev.lingvo.site.api.loadAsync
import dev.lingvo.site.ds.ControlHeight
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LArrowUpDownIcon
import dev.lingvo.site.ds.LBadge
import dev.lingvo.site.ds.LBellIcon
import dev.lingvo.site.ds.LBookOpenIcon
import dev.lingvo.site.ds.LBotIcon
import dev.lingvo.site.ds.LBoxIcon
import dev.lingvo.site.ds.LChartIcon
import dev.lingvo.site.ds.LChartLineIcon
import dev.lingvo.site.ds.LCheckIcon
import dev.lingvo.site.ds.LChevronLeftIcon
import dev.lingvo.site.ds.LCoinsIcon
import dev.lingvo.site.ds.LCommentIcon
import dev.lingvo.site.ds.LCreditCardIcon
import dev.lingvo.site.ds.LDangerIcon
import dev.lingvo.site.ds.LDisclosure
import dev.lingvo.site.ds.LDownloadIcon
import dev.lingvo.site.ds.LExternalLinkIcon
import dev.lingvo.site.ds.LFileIcon
import dev.lingvo.site.ds.LFilesIcon
import dev.lingvo.site.ds.LFolderIcon
import dev.lingvo.site.ds.LGlobeIcon
import dev.lingvo.site.ds.LGridIcon
import dev.lingvo.site.ds.LHelpIcon
import dev.lingvo.site.ds.LHistoryIcon
import dev.lingvo.site.ds.LInfoIcon
import dev.lingvo.site.ds.LKeyIcon
import dev.lingvo.site.ds.LLanguagesIcon
import dev.lingvo.site.ds.LListChecksIcon
import dev.lingvo.site.ds.LLockIcon
import dev.lingvo.site.ds.LMailIcon
import dev.lingvo.site.ds.LMenuIcon
import dev.lingvo.site.ds.LPresencePhase
import dev.lingvo.site.ds.LPresenceState
import dev.lingvo.site.ds.LReceiptIcon
import dev.lingvo.site.ds.LScrollTextIcon
import dev.lingvo.site.ds.LSearchField
import dev.lingvo.site.ds.LSelect
import dev.lingvo.site.ds.LSelectOption
import dev.lingvo.site.ds.LSmartphoneIcon
import dev.lingvo.site.ds.LSettingsIcon
import dev.lingvo.site.ds.LSheetEdge
import dev.lingvo.site.ds.LSkeleton
import dev.lingvo.site.ds.LSkeletonShape
import dev.lingvo.site.ds.LSparkleIcon
import dev.lingvo.site.ds.LSquareCheckIcon
import dev.lingvo.site.ds.LTrashIcon
import dev.lingvo.site.ds.LUserIcon
import dev.lingvo.site.ds.LUsersIcon
import dev.lingvo.site.ds.LVisuallyHiddenStyle
import dev.lingvo.site.ds.LWebhookIcon
import dev.lingvo.site.ds.LWordmarkGlyph
import dev.lingvo.site.ds.LWrenchIcon
import dev.lingvo.site.ds.LocalToasts
import dev.lingvo.site.ds.Motion
import dev.lingvo.site.ds.Radius
import dev.lingvo.site.ds.ScrimVars
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.ToastHost
import dev.lingvo.site.ds.ToastState
import dev.lingvo.site.ds.TypeScale
import dev.lingvo.site.ds.displayFont
import dev.lingvo.site.ds.formatCount
import dev.lingvo.site.ds.rememberLPresence
import dev.lingvo.site.ds.rememberToasts
import dev.lingvo.site.ds.sheetHidden
import dev.lingvo.site.ds.sheetLeaving
import dev.lingvo.site.ds.sheetSurface
import dev.lingvo.site.ds.toSitePalette
import dev.lingvo.site.ds.transitionColors
import dev.lingvo.site.i18n.t
import dev.lingvo.site.i18n.tPlural
import dev.lingvo.site.i18n.tr
import dev.lingvo.site.i18n.trf
import dev.lingvo.site.nav.AppDestination
import dev.lingvo.site.nav.AppNav
import dev.lingvo.site.nav.AppRoute
import dev.lingvo.site.nav.NavGlyph
import dev.lingvo.site.state.ProjectDirectory
import dev.lingvo.site.state.WorkspaceSelection
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.EventListener

private const val SIDEBAR_WIDTH = 248
private const val RAIL_WIDTH = 72

/**
 * The shell's stacking contract.
 *
 * These are names rather than ad-hoc numbers because the mobile navigation has to clear sticky
 * app chrome and editor utility surfaces without climbing above modal dialogs or toast notices.
 */
internal object AppLayer {
    const val Sidebar = 200
    const val StickyChrome = 250
    const val SkipLink = 500
    const val PickerScrim = 899
    const val PickerPopover = 900
    const val MobileNavigationTrigger = 260
    const val MobileNavigationScrim = 950
    const val MobileNavigationSurface = 951
}

/**
 * The skip link's target, stated once.
 *
 * Two places have to agree on it — the anchor's `href` and `<main>`'s `id` — and a skip link
 * pointing at an id that is not there is worse than none: it is a tab stop that silently does
 * nothing.
 */
private const val CONTENT_ID = "content"

/**
 * Whether one rail destination owns [currentPath].
 *
 * Landing destinations (`/app` and a project's Overview) are exact matches. They are also prefixes
 * of every sibling route, so treating them like section roots leaves two navigation items selected
 * on every deeper page. Section destinations keep prefix matching because routes such as Translate
 * and Settings legitimately own nested pages.
 */
internal fun appRailDestinationActive(currentPath: String, destination: AppDestination): Boolean {
    val path = currentPath.substringBefore('?').substringBefore('#').removeSuffix("/")
    val destinationPath = destination.path.removeSuffix("/")
    return when (destination.id) {
        "dashboard", "overview" -> path == destinationPath
        else -> path == destinationPath || path.startsWith("$destinationPath/")
    }
}

val AppShellRootStyle = CssStyle {
    base {
        Modifier
            .minHeight(100.vh)
            .backgroundColor(colorMode.toSitePalette().surfaceBase)
            .color(colorMode.toSitePalette().textPrimary)
    }
    // **The skip link.** There was none, so a keyboard or screen-reader user arriving on any page in
    // the app had to tab through the logo, every sidebar destination, the footer links, the trail,
    // the search field, the toggle and the account menu — twelve or more stops — before reaching the
    // thing they navigated to, on every single navigation.
    //
    // Clip-path rather than `display: none`, which would take it out of the accessibility tree and
    // out of the tab order, which is the entire point of it. Carried as a rule on the shell root
    // rather than as its own `CssStyle` so the shell adds no new top-level style to register.
    cssRule(" > [data-app-shell-background] > [data-skip-link]") {
        Modifier
            .position(Position.Absolute)
            .left(Space.LG)
            .top(Space.LG)
            .zIndex(AppLayer.SkipLink)
            .styleModifier {
                property("width", "1px")
                property("height", "1px")
                property("overflow", "hidden")
                property("clip-path", "inset(50%)")
                property("white-space", "nowrap")
                property("text-decoration", "none")
            }
    }
    cssRule(" > [data-app-shell-background] > [data-skip-link]:focus") {
        Modifier
            .height(44.px)
            .padding(leftRight = Space.LG)
            .backgroundColor(colorMode.toSitePalette().surface)
            .color(colorMode.toSitePalette().textPrimary)
            .borderRadius(Radius.Control)
            .fontSize(TypeScale.BodySmall)
            .fontWeight(600)
            // The floating stroke, never `border`: a control boundary at 1.41:1 is illegal.
            .outline(2.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier {
                property("width", "auto")
                property("clip-path", "none")
                property("overflow", "visible")
                property("display", "inline-flex")
                property("align-items", "center")
                property("border", "1px solid ${colorMode.toSitePalette().borderStrong}")
                property("outline-offset", "2px")
            }
    }
}

val AppSidebarStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.None)
            .position(Position.Fixed)
            .top(0.px)
            .bottom(0.px)
            .left(0.px)
            .width(RAIL_WIDTH.px)
            // **Paper, not `surface`.** `surface` on the main column's paper is a 1.07 fill doing a
            // hairline's job: the sidebar read as a faintly lighter panel, which is elevation by
            // fill on a light ground. The 1px `border` right edge is the whole boundary.
            .backgroundColor(colorMode.toSitePalette().surfaceBase)
            .borderRight(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
            .padding(topBottom = Space.LG, leftRight = Space.SM)
            // The desktop rail passes under the sticky bar. Compact navigation has its own named
            // overlay layer below, so opening it cannot be obscured by this desktop relationship.
            .zIndex(AppLayer.Sidebar)
    }
    Breakpoint.MD {
        Modifier
            .display(DisplayStyle.Block)
            .width(SIDEBAR_WIDTH.px)
            .padding(Space.LG)
    }
}

val AppMainStyle = CssStyle {
    base {
        Modifier
            .minHeight(100.vh)
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("margin-inline-start", "${SIDEBAR_WIDTH}px") }
    }
}

val AppTopBarStyle = CssStyle {
    base {
        Modifier
            // The bar lives in a column that aligns its children to the start, so without this it
            // shrinks to the width of the search field and the border stops mid-page.
            .fillMaxWidth()
            .position(Position.Sticky)
            .top(0.px)
            .height(56.px)
            .backgroundColor(colorMode.toSitePalette().surface)
            .borderBottom(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
            .zIndex(AppLayer.StickyChrome)
            // **56 on the left below MD, and it is not a spacing preference.**
            // `MobileNavigationTriggerStyle` is `position: fixed; left: 8` at `ControlHeight.MD`
            // wide, so it occupies x 8→48 at `z-index` 260 — above this bar's 250. At the desktop
            // 32px gutter the trigger painted its own surface and border across the first 16px of
            // the workspace crumb and took that slice of its hit area with it, on every phone, on
            // every page. 48 clears the button and the extra 8 is the gap the two would need
            // anyway. The right gutter stays put: nothing overlaps it.
            .padding(left = 56.px, right = Space.XXXL)
    }
    // 32 both sides from MD up, matching the content column's gutter, so the bar's first glyph and
    // the page's first glyph land on the same x. The trigger is `display: none` here.
    Breakpoint.MD { Modifier.padding(leftRight = Space.XXXL) }
}

val MobileNavigationTriggerStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(Space.SM)
            .left(Space.SM)
            .width(ControlHeight.MD)
            .height(ControlHeight.MD)
            .backgroundColor(colorMode.toSitePalette().surface)
            .color(colorMode.toSitePalette().textPrimary)
            .border(1.px, LineStyle.Solid, colorMode.toSitePalette().borderStrong)
            .borderRadius(Radius.Control)
            .zIndex(AppLayer.MobileNavigationTrigger)
    }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
    focusVisible {
        Modifier
            .outline(2.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier { property("outline-offset", "2px") }
    }
}

val MobileNavigationScrimStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(0.px)
            .right(0.px)
            .bottom(0.px)
            .left(0.px)
            .backgroundColor(ScrimVars.Sheet.value())
            .zIndex(AppLayer.MobileNavigationScrim)
            .styleModifier {
                // The panel's clock, not its own. The drawer beside this uses `sheetSurface()` —
                // 240ms — so a 180ms scrim finished dimming while the panel was still arriving,
                // and the two read as separate events rather than one surface.
                //
                // And a starting value, or the transition has nothing to run from: this declared an
                // entrance and only ever set `opacity: 0` on the way out, so the dim snapped on in
                // one frame and eased off — the same asymmetry `LModal`'s scrim had.
                property("transition", "opacity ${Motion.OverlayEnterMs}ms ${Motion.EaseEntrance}")
            }
    }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
    // Transparent on the frame it mounts, so the entrance above has a value to run from.
    cssRule("[data-presence=\"entering\"]") { Modifier.opacity(0) }
    cssRule("[data-presence=\"exiting\"]") {
        Modifier.styleModifier {
            property("opacity", "0")
            property("pointer-events", "none")
            property("transition", "opacity ${Motion.FastMs}ms ${Motion.EaseIn}")
        }
    }
}

val MobileNavigationSurfaceStyle = CssStyle {
    base {
        Modifier
            .position(Position.Fixed)
            .top(0.px)
            .bottom(0.px)
            .left(0.px)
            .width(280.px)
            .maxWidth(100.percent)
            .backgroundColor(colorMode.toSitePalette().surfaceBase)
            .borderRight(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
            .padding(Space.LG)
            .zIndex(AppLayer.MobileNavigationSurface)
            .styleModifier {
                property("max-width", "calc(100vw - 32px)")
                property("overflow-y", "auto")
            }
            // Arrives from outside the screen, not from six pixels away. See [Modifier.sheetSurface]:
            // six pixels is a menu's travel, and this panel is pinned to the edge of the viewport.
            .sheetSurface()
    }
    Breakpoint.MD { Modifier.display(DisplayStyle.None) }
    cssRule("[data-presence=\"entering\"]") { Modifier.sheetHidden(LSheetEdge.LEFT) }
    cssRule("[data-presence=\"exiting\"]") { Modifier.sheetLeaving(LSheetEdge.LEFT) }
}

@Composable
internal fun MobileNavigationFrame(
    open: Boolean,
    presence: LPresenceState,
    triggerId: String,
    onOpenChange: (Boolean) -> Unit,
    navigationContent: @Composable () -> Unit,
    backgroundContent: @Composable () -> Unit,
) {
    var compactViewport by remember { mutableStateOf(window.breakpointFloor < Breakpoint.MD) }
    DisposableEffect(onOpenChange) {
        val listener = EventListener {
            val compact = window.breakpointFloor < Breakpoint.MD
            compactViewport = compact
            if (!compact) onOpenChange(false)
        }
        window.addEventListener("resize", listener)
        onDispose { window.removeEventListener("resize", listener) }
    }

    // Read in composition because `t` is `@Composable` and the attrs builder below is not — the
    // lookup cannot be written where it is used. (An earlier version of this comment said a label
    // taken outside composition "would not survive a locale switch"; `I18n` is explicit that it
    // would, since the catalogue is fixed before the first composition and `switchTo` reloads the
    // page. The split is real, the stated reason was not.)
    val openNavigationLabel = t("app_shell.open_navigation", "Open navigation")
    // **The trigger leaves the tab order while the drawer is up.** It is rendered outside
    // `[data-app-shell-background]` so that it can sit above the sticky bar, which also meant the
    // `inert` below never reached it: the drawer is deliberately not a focus trap, so Shift+Tab off
    // its Close control landed here — on a button the drawer's own surface (`z-index` 951 against
    // this one's 260) is painted straight over. Focus disappeared behind the menu with nothing on
    // screen to say where it had gone, and the next Enter reopened a drawer that was already open.
    //
    // `tabindex`/`aria-hidden` rather than `inert`, because `inert` also suppresses the programmatic
    // `click()` a reopen depends on: the trigger stays pressable and focusable throughout, it just
    // stops being somewhere Tab can land. Both attributes are dropped in the same recomposition that
    // ends the presence, and the effect restoring focus to this button runs after that composition
    // is applied, so the restore still finds an ordinary trigger.
    val navigationVisible = compactViewport && (open || presence.rendered)
    Button(
        MobileNavigationTriggerStyle.toModifier().toAttrs {
            id(triggerId)
            type(ButtonType.Button)
            attr("data-mobile-navigation-trigger", "")
            attr("aria-label", openNavigationLabel)
            attr("aria-expanded", open.toString())
            attr("aria-controls", MOBILE_NAVIGATION_SURFACE_ID)
            if (navigationVisible) {
                attr("tabindex", "-1")
                attr("aria-hidden", "true")
            }
            onClick { onOpenChange(true) }
        },
    ) {
        LMenuIcon()
    }
    Div(
        Modifier
            .attr("data-app-shell-background", "")
            // `open` changes in the click event, while presence is requested from a later effect.
            // Both phases must block the background, but only while compact navigation is visible.
            .then(if (navigationVisible) Modifier.attr("inert", "") else Modifier)
            .toAttrs(),
    ) {
        backgroundContent()
    }
    if (compactViewport) {
        MobileNavigation(
            presence = presence,
            triggerId = triggerId,
            onOpenChange = onOpenChange,
            content = navigationContent,
        )
    }
}

/**
 * The content column: **1128 wide**, whatever the canvas is.
 *
 * The cap was 1440, which happens to produce 1128 of content on a 1440 canvas and nothing like it
 * anywhere else — on a 1600 canvas the column stretched to 1288 with the gutters stuck at 32, so
 * the measure grew with the monitor and long paragraphs ran to a width nobody can track back to the
 * next line. Capping the *box* at 1192 leaves exactly 1128 inside the 32 gutters and lets the
 * gutters absorb everything above that.
 *
 * Bottom padding is 72, not 32: the last control on a page needs room below it or it sits on the
 * viewport edge and reads as cut off.
 */
val AppContentStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .maxWidth((1128 + 64).px)
            // A 72px rail already consumes almost a quarter of a 320px viewport. Keeping the
            // desktop 32px gutters beside it left only 184px for the actual page, which is why
            // settings cards and tables looked as if they had no coherent padding at all.
            .padding(top = Space.XL, right = Space.LG, bottom = Space.Huge, left = Space.LG)
            .styleModifier {
                property("box-sizing", "border-box")
                property("margin", "0 auto")
            }
    }
    Breakpoint.MD {
        Modifier.padding(top = Space.XXXL, right = Space.XL, bottom = Space.Hero, left = Space.XL)
    }
    Breakpoint.LG {
        Modifier.padding(top = Space.XXXL, right = Space.XXXL, bottom = Space.Hero, left = Space.XXXL)
    }
}

/**
 * The strip the shell's notices sit in, between the top bar and the page.
 *
 * Gutters match [AppContentStyle] at every breakpoint, so a notice's first glyph lands on the same x
 * as the page heading under it. They used to copy the top bar's 56px left inset (the search field's
 * edge), which on a 375px phone floated the banner 40px right of the page and squeezed its text into
 * a 286px column that wrapped to seven lines. The bottom rule is what separates chrome from page —
 * the notices themselves are `LAlert`s now and carry their own hairline, so a second full-bleed
 * border under each of them would read as three stacked rules on a page with three notices.
 */
val ShellNoticeStackStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .gap(Space.SM)
            .padding(topBottom = Space.SM, leftRight = Space.LG)
            .borderBottom(1.px, LineStyle.Solid, colorMode.toSitePalette().border)
    }
    Breakpoint.MD { Modifier.padding(topBottom = Space.SM, leftRight = Space.XL) }
    Breakpoint.LG { Modifier.padding(topBottom = Space.SM, leftRight = Space.XXXL) }
}

val AppLogoStyle = CssStyle {
    base {
        Modifier
            .height(ControlHeight.MD)
            .width(100.percent)
            .color(colorMode.toSitePalette().textPrimary)
            .borderRadius(Radius.Control)
            .outline(0.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("gap", Space.SM.toString())
                property("justify-content", "center")
                property("text-decoration", "none")
            }
    }
    Breakpoint.MD {
        Modifier.styleModifier { property("justify-content", "flex-start") }
    }
    focusVisible {
        Modifier
            .outline(2.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier { property("outline-offset", "2px") }
    }
}

val AppLogoMarkStyle = CssStyle.base {
    Modifier
        // The glyph box, not the link's own hit area (that's AppLogoStyle, at ControlHeight.MD) —
        // a decorative square happening to share its number, not a control height in its own right.
        .width(40.px)
        .minWidth(40.px)
        .height(40.px)
        .color(colorMode.toSitePalette().accent)
        .fontSize(TypeScale.HeadingSmall)
        .fontWeight(700)
        .lineHeight(1)
        .styleModifier {
            property("display", "inline-flex")
            property("align-items", "center")
            property("justify-content", "center")
        }
}

/**
 * A sidebar group heading — `YOU`, `WORKSPACE`.
 *
 * 16 tall with 8 below, per the shell spec, and hidden below MD where the sidebar collapses to an
 * icon rail: a heading over a column of bare icons labels nothing and costs a row.
 */
val AppNavGroupLabelStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.None)
            .color(colorMode.toSitePalette().textMuted)
            .fontSize(TypeScale.Micro)
            .fontWeight(600)
            .letterSpacing(TypeScale.MicroTracking)
            .lineHeight(16.px)
            .padding(left = Space.MD, bottom = Space.XS)
            .styleModifier { property("text-transform", "uppercase") }
    }
    Breakpoint.MD { Modifier.display(DisplayStyle.Block) }
}

/**
 * The rule above the footer block.
 *
 * Inset to the sidebar's inner column rather than run full width, so it separates the destinations
 * from Settings and Help without drawing a line across the whole rail.
 */
val AppNavDividerStyle = CssStyle.base {
    Modifier
        .width(100.percent)
        .height(1.px)
        .backgroundColor(colorMode.toSitePalette().border)
}

val AppNavItemStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .height(ControlHeight.MD)
            .color(colorMode.toSitePalette().textSecondary)
            .borderRadius(Radius.Control)
            .padding(0.px)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("gap", Space.MD.toString())
                property("text-decoration", "none")
            }
            .transitionColors()
    }
    Breakpoint.MD {
        Modifier
            .padding(leftRight = Space.MD)
            .styleModifier { property("justify-content", "flex-start") }
    }
    cssRule(":hover") {
        // `surfaceRaised` is pure white and is reserved for things that genuinely float. A hovered
        // nav item does not float; it is the paper's own second step.
        Modifier
            .backgroundColor(colorMode.toSitePalette().surfaceSunken)
            .color(colorMode.toSitePalette().textPrimary)
    }
    focusVisible {
        Modifier
            .outline(2.px, LineStyle.Solid, colorMode.toSitePalette().accent)
            .styleModifier { property("outline-offset", "2px") }
    }
    // The fill identifies the current page. Stronger icon weight also distinguishes it when
    // the narrow rail hides labels, without adding a selection border or moving its contents.
    cssRule("[aria-current=\"page\"] > svg") {
        Modifier.styleModifier { property("stroke-width", "3") }
    }
}

@Composable
fun AppShell(content: @Composable ColumnScope.() -> Unit) {
    // Kobweb's route is Compose state; window.location.pathname is not. Reading the raw location
    // left the shell (breadcrumbs, active nav item, project switcher) showing the previous route
    // after a client-side navigation — most visibly, creating a project landed you on its page
    // while the switcher still read "Select a project".
    val currentPath = rememberPageContext().route.path.trimEnd('/').ifBlank { "/" }
    val projectReads = rememberAppShellProjectReads(currentPath)
    // **One toast channel for the whole app.** `LocalToasts` was declared with a default that
    // throws and was never provided, so eleven pages hand-rolled their own host and every other
    // mutating page had nowhere to report success or failure at all — and a page that toasted and
    // then routed away unmounted its own host before the message could be read.
    val toasts = rememberToasts()
    // The command palette lives outside this composition (see [ShellToastHost]), so the host has to
    // be reachable by name for as long as the shell is on screen.
    DisposableEffect(toasts) {
        ShellToastHost.publish(toasts)
        onDispose { ShellToastHost.withdraw(toasts) }
    }
    var mobileNavigationOpen by remember { mutableStateOf(false) }
    val mobileNavigationPresence = rememberLPresence(mobileNavigationOpen, Motion.FastMs)
    // **Navigating closes the drawer.** Its contents are router links, so choosing one swapped the
    // page underneath a full-screen overlay that stayed open, kept its scroll lock, and kept focus
    // trapped inside itself. On a phone that reads as a tap that did nothing — the destination is
    // already rendered, hidden behind the menu the reader must dismiss by hand to discover it.
    LaunchedEffect(currentPath) { mobileNavigationOpen = false }
    // One tab title for all forty-odd app routes; see [AppDocumentTitle].
    AppDocumentTitle(currentPath)
    CompositionLocalProvider(LocalToasts provides toasts, LocalAppShellProjectReads provides projectReads) {
        Div(AppShellRootStyle.toModifier().toAttrs()) {
            MobileNavigationFrame(
                open = mobileNavigationOpen,
                presence = mobileNavigationPresence,
                triggerId = MOBILE_NAVIGATION_TRIGGER_ID,
                onOpenChange = { mobileNavigationOpen = it },
                navigationContent = { SidebarContent(currentPath) },
            ) {
                // The first tab stop of the shell, before the sidebar, on every page. A plain anchor to
                // a fragment rather than a router link: this must move focus into `<main>`, not
                // navigate, and the browser's own fragment behaviour is the only thing that does that
                // without a scroll handler of our own.
                A(
                    href = "#$CONTENT_ID",
                    attrs = { attr("data-skip-link", "") },
                ) {
                    Text(t("app_shell.skip_to_content", "Skip to content"))
                }
                Sidebar(currentPath)
                Column(AppMainStyle.toModifier()) {
                    AppTopBar(currentPath)
                    ShellNotices(currentPath)
                    // `tabindex="-1"` alongside the id, because without it the skip link moves the
                    // browser's scroll position and nothing else: a `<main>` that is not focusable is
                    // not a focus target, so the next Tab press starts again from the logo.
                    Main(
                        AppContentStyle.toModifier().toAttrs {
                            id(CONTENT_ID)
                            attr("tabindex", "-1")
                        },
                    ) {
                        Column(Modifier.fillMaxWidth()) {
                            // Drawn by the shell rather than by each page, so a new settings page or a
                            // new project tab is reachable the moment it is registered — which is the
                            // whole reason seventeen finished pages had no inbound link.
                            // **No project pill row.** The rail carries the project's destinations now
                            // (`AppNav.railFor`), and drawing them a second time under the top bar is
                            // the duplication the project overview spent four commits removing — two
                            // lists of the same destinations, in two visual languages, sixty pixels
                            // apart. Settings keeps its row: the settings rail is the workspace rail,
                            // so its fourteen destinations genuinely are one level down.
                            // Asked of the nav model rather than of the path. The row draws the
                            // settings group this page belongs to, and `settingsGroupFor` is what
                            // decides whether there is one — `/app/account/security` and
                            // `/app/workspaces` are settings destinations that do not start with
                            // `/app/settings`, so a `startsWith` left them with no row at all while
                            // the hub happily linked to them.
                            if (AppNav.settingsGroupFor(WorkspaceSelection.current()?.role, currentPath) != null) {
                                SettingsNav(currentPath)
                            }
                            Column(Modifier.fillMaxWidth(), content = content)
                        }
                    }
                }
                ToastHost(toasts)
            }
        }
    }
}

/**
 * One thing the shell has to say across every page, ranked against the others.
 *
 * The banners used to each decide for themselves whether to paint, and they painted independently:
 * a workspace whose card had failed, whose owner had not verified their address, and whose selection
 * had just moved in another tab showed three stacked bars above the page, pushing the content down
 * by 150px and making the one that mattered the least prominent of the three. A notice that returns
 * a value instead can be ranked, and only the top one is a bar.
 */
internal data class ShellNotice(
    val id: String,
    val title: String,
    val description: String?,
    val variant: LAlertVariant,
    val action: (@Composable () -> Unit)? = null,
)

/**
 * The shell's notice stack: one bar, and a disclosure for whatever else applies.
 *
 * Order is by what it costs the reader to miss — a failing card ends a subscription, a missing
 * provider silently disables every automation in the product, a moved workspace makes the next
 * action apply somewhere else, and an unverified address costs nothing today. The rest are counted,
 * not hidden: `+2 notices` is a control that names how much it is holding, and it is collapsed by
 * default because a page is for the page.
 */
@Composable
internal fun ShellNotices(currentPath: String) {
    ShellNoticeStack(
        listOfNotNull(
            pastDueNotice(),
            noProviderNotice(),
            workspaceDriftNotice(currentPath),
            verifyEmailNotice(),
        ),
    )
}

/**
 * Draws a ranked notice list: the first one, and a disclosure for the rest.
 *
 * Separate from [ShellNotices] because collecting the notices needs a session, a workspace and two
 * endpoints, while *this* — one bar visible, the rest counted behind a control that says how many —
 * is the behaviour worth pinning, and it is decided entirely by the list it is handed.
 */
@Composable
internal fun ShellNoticeStack(notices: List<ShellNotice>) {
    if (notices.isEmpty()) return
    var expanded by remember { mutableStateOf(false) }
    val rest = notices.drop(1)
    Column(ShellNoticeStackStyle.toModifier(), horizontalAlignment = Alignment.Start) {
        notices.first().let { head ->
            LAlert(
                title = head.title,
                description = head.description,
                modifier = Modifier.fillMaxWidth().attr("data-shell-notice", head.id),
                variant = head.variant,
                action = head.action,
                dense = true,
            )
        }
        if (rest.isNotEmpty()) {
            LDisclosure(
                title = tPlural(
                    "app_shell.count.notice",
                    rest.size,
                    "{count} more notice",
                    "{count} more notices",
                ),
                expanded = expanded,
                onExpandedChange = { expanded = it },
                modifier = Modifier.fillMaxWidth().attr("data-shell-notice-more", ""),
                icon = { LInfoIcon() },
            ) {
                Column(Modifier.fillMaxWidth().gap(Space.SM)) {
                    rest.forEach { notice ->
                        LAlert(
                            title = notice.title,
                            description = notice.description,
                            modifier = Modifier.fillMaxWidth().attr("data-shell-notice", notice.id),
                            variant = notice.variant,
                            action = notice.action,
                            dense = true,
                        )
                    }
                }
            }
        }
    }
}

/**
 * The shell's own toast channel, reachable from outside its composition.
 *
 * [CommandPaletteHost] is mounted by `AuthGuard` *after* `content()`, which is where the shell and
 * its `LocalToasts` provider live — so the palette cannot read the local, and an action row that
 * spent credits had nowhere to report the receipt. Published from the shell rather than lifted into
 * `AuthGuard` because the editor route calls `AuthGuard` without a shell at all and owns its own
 * host; this way the palette uses the shell's host on shell routes and its own fallback elsewhere.
 */
internal object ShellToastHost {
    var state: ToastState? by mutableStateOf(null)
        private set

    fun publish(toasts: ToastState) {
        state = toasts
    }

    fun withdraw(toasts: ToastState) {
        if (state === toasts) state = null
    }
}

@Composable
internal fun MobileNavigation(
    presence: LPresenceState,
    triggerId: String,
    onOpenChange: (Boolean) -> Unit,
    content: @Composable () -> Unit,
) {
    var everOpened by remember { mutableStateOf(false) }
    LaunchedEffect(presence.rendered, presence.phase, triggerId) {
        if (presence.rendered && presence.phase != LPresencePhase.EXITING) {
            everOpened = true
            (document.getElementById(mobileNavigationCloseId(triggerId)) as? HTMLElement)?.focus()
        } else if (!presence.rendered && everOpened) {
            (document.getElementById(triggerId) as? HTMLElement)?.focus()
        }
    }
    if (!presence.rendered) return

    val exiting = presence.phase == LPresencePhase.EXITING
    Div(
        MobileNavigationScrimStyle.toModifier()
            .attr("data-mobile-navigation-scrim", "")
            .attr("data-presence", presence.phase.attributeValue)
            .then(if (exiting) Modifier.attr("inert", "").attr("aria-hidden", "true") else Modifier)
            .onClick { onOpenChange(false) }
            .toAttrs(),
    ) {}
    Nav(
        MobileNavigationSurfaceStyle.toModifier()
            .attr("id", MOBILE_NAVIGATION_SURFACE_ID)
            .attr("data-mobile-navigation-surface", "")
            .attr("data-presence", presence.phase.attributeValue)
            .attr("aria-label", tr("app_shell.primary_navigation", "Primary navigation"))
            .then(if (exiting) Modifier.attr("inert", "").attr("aria-hidden", "true") else Modifier)
            .onKeyDown { event ->
                if (event.key == "Escape") {
                    event.preventDefault()
                    onOpenChange(false)
                }
            }
            .toAttrs(),
    ) {
        Button(
            Modifier
                .fillMaxWidth()
                .height(ControlHeight.MD)
                .margin(bottom = Space.MD)
                .backgroundColor(ColorMode.current.toSitePalette().surfaceSunken)
                .color(ColorMode.current.toSitePalette().textPrimary)
                // `borderStrong`, not `border`. The latter is the divider tone — 1.32:1 in light,
                // which the palette's own comment calls "a divider, never a control boundary" — and
                // this is the only control in the drawer, so its edge was the one thing a reader
                // had to find. WCAG 1.4.11 wants 3:1 for it; `borderStrong` measures 3.67.
                .border(1.px, LineStyle.Solid, ColorMode.current.toSitePalette().borderStrong)
                .borderRadius(Radius.Control)
                .toAttrs {
                    id(mobileNavigationCloseId(triggerId))
                    type(ButtonType.Button)
                    attr("data-mobile-navigation-close", "")
                    attr("aria-label", tr("app_shell.close_navigation", "Close navigation"))
                    onClick { onOpenChange(false) }
                },
        ) {
            Text(tr("app_shell.close_navigation", "Close navigation"))
        }
        content()
    }
}

private const val MOBILE_NAVIGATION_TRIGGER_ID = "lingvo-mobile-navigation-trigger"
private const val MOBILE_NAVIGATION_SURFACE_ID = "lingvo-mobile-navigation"

private fun mobileNavigationCloseId(triggerId: String) = "$triggerId-close"

/**
 * @param roleResolving the session has not answered yet. The sidebar draws its **settled shape** —
 *   real logo, real group labels, the real role-blind links, the real footer — and holds only the
 *   two role-gated slots with skeletons. The loading shell used to skeleton the entire rail, so
 *   every navigation replaced the nav with five grey bars and then pushed the footer as the real
 *   items arrived at a different height.
 */
@Composable
private fun Sidebar(currentPath: String, roleResolving: Boolean = false) {
    Nav(AppSidebarStyle.toModifier().toAttrs { attr("aria-label", tr("app_shell.primary_navigation", "Primary navigation")) }) {
        SidebarContent(currentPath, roleResolving)
    }
}

@Composable
private fun SidebarContent(currentPath: String, roleResolving: Boolean = false) {
    Column(
        Modifier.fillMaxWidth().height(100.percent).gap(Space.LG),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
            Link(
                path = "/app",
                modifier = AppLogoStyle.toModifier()
                    .attr("aria-label", t("app_shell.lingvo_home", "Lingvo home"))
                    // i18n-ignore — the product name, which is the same word in every locale.
                    .attr("title", "Lingvo"), // i18n-ignore
                variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
            ) {
                LWordmarkGlyph(AppLogoMarkStyle.toModifier())
                Span(
                    Modifier
                        .displayIfAtLeast(Breakpoint.MD)
                        .displayFont()
                        .fontSize(TypeScale.HeadingSmall)
                        .fontWeight(700)
                        .toAttrs(),
                ) {
                    Text(t("app_shell.lingvo", "Lingvo"))
                }
            }
            // **No switchers here any more.** A project switcher was the most prominent control in
            // the app and applied to sixteen of its fifty-seven routes; on the other forty-one it
            // read "Select a project". Both switchers moved into the top bar's trail, where they
            // state where you are instead of asking, and where every option is a real link. The
            // sidebar is destinations, and only destinations.
            // Drawn from the role this person actually holds. The sidebar previously hardcoded every
            // destination, including a deep link to `/app/settings/tokens` — so it could not hide
            // anything from anyone, and every workspace-level settings page added later would have
            // been offered to translators who cannot open it.
            // **The role in *this* workspace, and nothing else.** `strongestRole()` is the best role
            // held across every workspace somebody belongs to, so an owner of their own workspace
            // who is a translator in a client's saw an owner's navigation while looking at the
            // client's — and every page it linked to then refused them, because the server asks the
            // narrower question. It was left here as a fallback, which is the same bug on the path
            // that matters most: no rendered workspace is exactly when the guess is least informed.
            // Null flows through to the role-blind subset instead.
            val role = if (roleResolving) null else WorkspaceSelection.current()?.role
            // Two labelled groups, not five loose links. The labels are specified copy: `YOU` for
            // the surfaces about the person reading, `WORKSPACE` for the ones about the workspace.
            // The same resolution `ProjectNav` used before the rail absorbed it: the project's first
            // non-source locale, from the directory the trail already reads. Null while the
            // directory loads, which drops `Translate` rather than pointing it at a blank locale.
            val railProject = ProjectDirectory.find(AppRoute.projectSlug(currentPath))
            val railFirstTarget = railProject?.locales?.firstOrNull { it != railProject.sourceLocale }
            val rail = AppNav.railFor(role, currentPath, railFirstTarget)
            // `QA 12`, `Proposals 3`, `Your work 42` — from data a page already asks for, not a
            // second request built for a badge. See [railCounts].
            val counts = railCounts(
                scope = rail.scope,
                slug = railProject?.slug,
                workspaceSlug = WorkspaceSelection.current()?.slug,
                roleResolving = roleResolving,
            )
            val groups = when {
                rail.scope == AppNav.RailScope.PROJECT -> AppNav.projectGroupsFor(rail.destinations)
                roleResolving -> AppNav.primaryGroupsWhileResolving()
                else -> AppNav.primaryGroupsFor(role)
            }
            // **The way out, and it names where it goes.** `← All projects`, not `← Storefront`:
            // `BRAND.md` binds a control to name its action and the result to match it, and a
            // control labelled with where you *are* while navigating somewhere else breaks that.
            // Which project you are in is said by the trail above and by the page's own H1.
            rail.backPath?.let { path ->
                NavItem(t("app_shell.all_projects", "All projects"), path, active = false) { LChevronLeftIcon() }
            }
            Column(Modifier.fillMaxWidth().gap(Space.MD)) {
                groups.forEach { (label, destinations) ->
                    Column(Modifier.fillMaxWidth().gap(Space.XS)) {
                        label?.let {
                            // Keyed by a slug of the English, because these headings are class-init
                            // `val`s in the nav model — a lookup written there would freeze in
                            // English for the life of the page, exactly as the destination labels
                            // two lines below do. `extract-strings.mjs` mints the same key.
                            Div(AppNavGroupLabelStyle.toModifier().toAttrs()) {
                                Text(t(AppNav.navGroupKey(it), it))
                            }
                        }
                        if (roleResolving && destinations.any(AppNav::isRoleGated)) {
                            Span(LVisuallyHiddenStyle.toModifier().toAttrs { attr("role", "status") }) {
                                Text(t("app_shell.loading_navigation", "Loading navigation"))
                            }
                        }
                        destinations.forEach { destination ->
                            if (roleResolving && AppNav.isRoleGated(destination)) {
                                // The slot, held at the item's own height so nothing below it moves
                                // when the answer arrives — and never the item itself, because a
                                // link drawn before the role is known is a link that may be refused.
                                // Decorative. This sits inside `destinations.forEach`, so the label
                                // was not one announcement — it was one per held slot, all saying
                                // the same sentence. The rail announces once, above the loop.
                                LSkeleton(height = ControlHeight.MD, label = null)
                            } else {
                                val active = appRailDestinationActive(currentPath, destination)
                                // Translated here, not in the nav model. `AppNav`'s destination
                                // lists are top-level `val`s built at class-init, long before a
                                // catalogue is fetched, so a `t(...)` inside them would freeze in
                                // English for the life of the page. The id is stable and already
                                // the key for this destination's icon, so it keys its label too.
                                NavItem(
                                    t("nav.${destination.catalogueKey}", destination.label),
                                    destination.path,
                                    active,
                                    count = counts[destination.id],
                                ) {
                                    NavIcon(destination.glyph)
                                }
                            }
                        }
                    }
                }
            }
            Spacer()
            // The footer: a rule, then whatever `railFooterItemsFor` says this person gets.
            // Measured up from the bottom, so only the spacer above it changes with the viewport.
            //
            // Drawn from that list rather than three hand-written items, because a test that
            // describes the footer in parallel with the code that draws it is a test that passes
            // while the two disagree — which is exactly how the workspace Settings came to be
            // asserted "reachable" by a check that could not fail.
            Column(Modifier.fillMaxWidth().gap(Space.XS)) {
                Div(
                    AppNavDividerStyle.toModifier()
                        .margin(topBottom = Space.MD)
                        .toAttrs { attr("role", "presentation") },
                ) {}
                railFooterItemsFor(role).forEach { item ->
                    // **These two ids are minted in this file, so `nav.<id>` has nothing to find.**
                    // `extract-strings.mjs` reads its `nav.*` keys out of the nav model, and
                    // `railFooterItemsFor` writes `Workspace settings` and `Lingvo home` here — so
                    // both lookups missed, fell back to their English, and two rows that are on
                    // screen on every authenticated page could not be translated at all. Help comes
                    // from `AppNav.help` and keeps the model's key.
                    val label = when (item.id) {
                        WORKSPACE_SETTINGS_ID -> t("app_shell.workspace_settings", "Workspace settings")
                        LINGVO_HOME_ID -> t("app_shell.lingvo_home", "Lingvo home")
                        else -> t("nav.${item.id}", item.label)
                    }
                    NavItem(label, item.path, railFooterActive(item.id, currentPath)) {
                        NavIcon(item.glyph)
                    }
                }
            }
        }
}

/**
 * The one drawing of a [NavGlyph], for every rail, pill row and palette row in the app.
 *
 * **There is no fallback and no `id` any more.** This used to take a destination id, look it up in
 * a `navGlyphFor` `when`, and render `LGlobeIcon()` for anything the `when` had never heard of.
 * Twice that swallowed real destinations: first Inbox and Dashboard, then the whole eight-item
 * project rail, which shipped as eight identical globes. The mark is now a required field on
 * [AppDestination], so a destination without one does not compile and there is nothing left for a
 * fallback to catch — the `when` below is exhaustive over the enum and the compiler says so.
 *
 * The rails are mutually exclusive — you are either in the workspace or inside a project — so a few
 * marks appear in both (grid for Dashboard and Overview, check for Your work and QA, file for
 * Projects and Glossary). That repetition is never visible on one screen; two identical marks in
 * *one* rail is the failure `NavIconCoverageTest` guards against.
 *
 * `translate` keeps the globe on purpose: it is the one destination the generic mark actually means.
 */
@Composable
internal fun NavIcon(glyph: NavGlyph) {
    when (glyph) {
        NavGlyph.ArrowUpDown -> LArrowUpDownIcon()
        NavGlyph.Bell -> LBellIcon()
        NavGlyph.BookOpen -> LBookOpenIcon()
        NavGlyph.Bot -> LBotIcon()
        NavGlyph.Box -> LBoxIcon()
        NavGlyph.Chart -> LChartIcon()
        NavGlyph.ChartLine -> LChartLineIcon()
        NavGlyph.Check -> LCheckIcon()
        NavGlyph.Coins -> LCoinsIcon()
        NavGlyph.Comment -> LCommentIcon()
        NavGlyph.CreditCard -> LCreditCardIcon()
        NavGlyph.Danger -> LDangerIcon()
        NavGlyph.Download -> LDownloadIcon()
        NavGlyph.ExternalLink -> LExternalLinkIcon()
        NavGlyph.File -> LFileIcon()
        NavGlyph.Files -> LFilesIcon()
        NavGlyph.Folder -> LFolderIcon()
        NavGlyph.Globe -> LGlobeIcon()
        NavGlyph.Grid -> LGridIcon()
        NavGlyph.Help -> LHelpIcon()
        NavGlyph.History -> LHistoryIcon()
        NavGlyph.Key -> LKeyIcon()
        NavGlyph.Languages -> LLanguagesIcon()
        NavGlyph.ListChecks -> LListChecksIcon()
        NavGlyph.Lock -> LLockIcon()
        NavGlyph.Mail -> LMailIcon()
        NavGlyph.Receipt -> LReceiptIcon()
        NavGlyph.ScrollText -> LScrollTextIcon()
        NavGlyph.Settings -> LSettingsIcon()
        NavGlyph.Smartphone -> LSmartphoneIcon()
        NavGlyph.Sparkle -> LSparkleIcon()
        NavGlyph.SquareCheck -> LSquareCheckIcon()
        NavGlyph.Trash -> LTrashIcon()
        NavGlyph.User -> LUserIcon()
        NavGlyph.Users -> LUsersIcon()
        NavGlyph.Webhook -> LWebhookIcon()
        NavGlyph.Wrench -> LWrenchIcon()
    }
}

internal const val WORKSPACE_SETTINGS_ID = "workspace-settings"
internal const val LINGVO_HOME_ID = "lingvo-home"


/** The id of a scope's own settings destination, in either rail's destination list. */
internal const val SCOPE_SETTINGS_ID = "settings"

/** One row pinned under the rail's divider. */
internal data class RailFooterItem(val id: String, val label: String, val path: String, val glyph: NavGlyph)

/**
 * The rows pinned under the divider, for this person — **the list the rail actually draws**.
 *
 * This is the third revision of the same idea and the first one connected to anything. It began as
 * a constant of three ids that a test read while the footer hand-wrote its three items beside it;
 * the test then asserted the workspace Settings was "reachable" by checking a constant that always
 * contained it, so it could not have failed however the footer behaved. The footer now renders from
 * this function, so the assertion and the pixels have one source.
 *
 * The workspace Settings drops out exactly when [AppNav.settingsLandingFor] has nowhere to send
 * this person — the same condition the footer used inline before — rather than when some other part
 * of the rail happens to carry a Settings of its own. An earlier revision suppressed it on that
 * second rule and thereby hid billing and members from the workspace owners who are the only people
 * who can open them.
 *
 * `Lingvo home` is not role-gated: leaving for the marketing site is available to anyone who can
 * see a rail at all.
 */
internal fun railFooterItemsFor(role: Role?): List<RailFooterItem> = listOfNotNull(
    // "Workspace settings", not "Settings": a project rail carries the project's own Settings a few
    // rows above this one, and two rows under one name is what sent the icons hunting for a second
    // gear to begin with.
    AppNav.settingsLandingFor(role)?.let {
        RailFooterItem(WORKSPACE_SETTINGS_ID, "Workspace settings", it, NavGlyph.Settings)
    },
    // A page that already existed and that nothing linked to. It is also the page that still renders
    // when the API does not, which makes being unreachable from the shell exactly the wrong way
    // round.
    RailFooterItem(AppNav.help.id, AppNav.help.label, AppNav.help.path, AppNav.help.glyph),
    // The way back out. Every route into the product is one-way once you are inside it: the wordmark
    // above goes to `/app` (which is what a logo in an app shell should do), and nothing else on any
    // of the fifty-odd app routes points at `/`. Pricing, the docs and the changelog all live out
    // there, so somebody who wants to check what a plan includes has to edit the URL.
    RailFooterItem(LINGVO_HOME_ID, "Lingvo home", "/", NavGlyph.ExternalLink),
)

/**
 * Whether a pinned row is the current page.
 *
 * `Lingvo home` is never active: `/` is a prefix of every path in the product, so the usual
 * `startsWith` test would light it on every page in the app.
 */
internal fun railFooterActive(id: String, currentPath: String): Boolean = when (id) {
    WORKSPACE_SETTINGS_ID -> currentPath.startsWith("/app/settings")
    AppNav.help.id -> currentPath.startsWith(AppNav.help.path)
    else -> false
}

/**
 * One rail badge: the number, and the sentence a screen reader hears in its place.
 *
 * **The sentence is not the number with the label glued to it.** `"QA, 12"` is what a concatenation
 * produces and it is wrong twice — it is untranslatable, and 12 QA *errors* are counted as strings
 * with errors rather than as issues, so "12" beside "QA" reads as twelve pages, twelve rules, or
 * twelve of whatever the reader guesses. Each count states its own noun.
 */
internal data class RailCount(val value: Int, val accessibleName: String)

/** Strings carrying at least one blocking QA error — not issues, and not "QA, 12". */
internal fun qaErrorsRailCount(errors: Int): RailCount = RailCount(
    errors,
    tPlural(
        "app_shell.count.string_with_errors",
        errors,
        "{count} string with errors",
        "{count} strings with errors",
    ),
)

internal fun proposalsRailCount(total: Int): RailCount = RailCount(
    total,
    tPlural(
        "app_shell.count.proposal_waiting",
        total,
        "{count} proposal waiting",
        "{count} proposals waiting",
    ),
)

/**
 * Everything waiting on this person, across every section the queue builds.
 *
 * `WorkSectionDto.total` is already the sum of its items' counts, so this is the queue's own number
 * rather than a second reading of it — the rail and `/app/work` cannot disagree.
 */
internal fun workRailCount(response: WorkResponse): RailCount {
    val waiting = response.sections.sumOf(WorkSectionDto::total)
    return RailCount(
        waiting,
        tPlural(
            "app_shell.count.string_waiting_on_you",
            waiting,
            "{count} string waiting on you",
            "{count} strings waiting on you",
        ),
    )
}

internal fun mentionsRailCount(mentions: Int): RailCount = RailCount(
    mentions,
    tPlural("app_shell.count.mention", mentions, "{count} mention", "{count} mentions"),
)

/**
 * What a screen reader hears on a rail row, count and all.
 *
 * A badge only sighted readers can see would tell a screen-reader user "QA" and a mouse user "QA
 * 12". The sentence comes from the count itself, so it names what was counted rather than gluing a
 * number onto a destination's label in English word order.
 */
internal fun navItemAccessibleName(label: String, count: RailCount?): String = count?.let {
    trf(
        "app_shell.label_count",
        "{label}, {count}",
        "label" to label,
        "count" to it.accessibleName,
    )
} ?: label

/**
 * The numbers the rail draws, for whichever rail is up.
 *
 * Every one of them already exists server-side: `GET /work` sums the sections it is already
 * building, `GET /me/mentions` is the inbox itself, `GET /readiness` computes QA errors per locale
 * for [ReadinessBand], and `GET /proposals` returns its own `total`. Nothing here is a new endpoint,
 * so this does not run into the brief's own rule — ship the rail without counts rather than fetch
 * for a badge — because there is nothing new to fetch *for*. What that rule still forbids is a
 * placeholder: a count is drawn only once its request actually answers, never as a confident zero
 * that would have to correct itself a moment later, which is why an id is simply absent from the
 * map while loading or on failure rather than mapped to 0.
 *
 * Keyed on the subject, not the path: moving between two pages of the same project or workspace must
 * not re-fetch, but opening a different one must.
 */
@Composable
private fun railCounts(
    scope: AppNav.RailScope,
    slug: String?,
    workspaceSlug: String?,
    roleResolving: Boolean,
): Map<String, RailCount> {
    if (roleResolving) return emptyMap()
    return if (scope == AppNav.RailScope.PROJECT && slug != null) {
        val reads = LocalAppShellProjectReads.current
        buildMap {
            reads?.qa?.let { put("qa", qaErrorsRailCount(it)) }
            reads?.proposals?.let { put("proposals", proposalsRailCount(it)) }
        }
    } else if (workspaceSlug != null) {
        val work = loadAsync(workspaceSlug) { ApiClient.work(workspaceSlug) }
        val mentions = loadAsync(workspaceSlug) { ApiClient.mentions() }
        buildMap {
            (work as? Async.Success)?.value?.let { put("work", workRailCount(it)) }
            (mentions as? Async.Success)?.value?.let { put("inbox", mentionsRailCount(it.size)) }
        }
    } else {
        emptyMap()
    }
}

@Composable
internal fun NavItem(
    label: String,
    path: String,
    active: Boolean,
    // Countable things are shown as counts (`PRODUCT.md` principle 4) — never a dot, never a "!".
    // Null while it has not arrived yet, which draws nothing rather than a zero that would have to
    // correct itself a moment later.
    count: RailCount? = null,
    icon: @Composable () -> Unit,
) {
    val palette = ColorMode.current.toSitePalette()
    Link(
        path = path,
        modifier = AppNavItemStyle.toModifier()
            .then(
                if (active) {
                    Modifier.backgroundColor(palette.accentSubtle).color(palette.accent)
                } else {
                    Modifier
                },
            )
            // See [navItemAccessibleName].
            .attr("aria-label", navItemAccessibleName(label, count))
            .attr("title", label)
            .then(if (active) Modifier.attr("aria-current", "page") else Modifier),
        variant = UndecoratedLinkVariant.then(UncoloredLinkVariant),
    ) {
        icon()
        Span(
            Modifier
                .displayIfAtLeast(Breakpoint.MD)
                .flexGrow(1)
                .fontSize(TypeScale.BodySmall)
                .fontWeight(if (active) 700 else 600)
                .toAttrs(),
        ) {
            Text(label)
        }
        // **A zero draws no badge.** The condition was `count != null`, so "Inbox 0" sat in the
        // rail on every page — a count badge exists to pull the eye, and a zero pulls it to nothing.
        // The dashboard's readiness counters already made this call in writing. The accessible name
        // keeps stating the number, where "0 mentions" is an answer rather than a decoration.
        if (count != null && count.value > 0) {
            LBadge(
                text = formatCount(count.value),
                modifier = Modifier.displayIfAtLeast(Breakpoint.MD).attr("aria-hidden", "true"),
            )
        }
    }
}

/**
 * The shell while the session is still resolving.
 *
 * **It holds the settled shape rather than skeletoning the furniture.** It used to draw a circle
 * where the logo goes and five grey bars where the nav goes, so every cold load and every
 * re-authentication replaced the whole chrome and then re-laid it out at a different height when the
 * real items arrived. Everything that does not depend on the answer — logo, group labels, the
 * role-blind links, the divider, Settings, Help, the search field — is drawn for real, and only the
 * four things that genuinely await the session are held: the two role-gated nav slots, the trail,
 * the colour toggle and the account trigger.
 */
@Composable
fun AppShellLoading() {
    val currentPath = rememberPageContext().route.path.trimEnd('/').ifBlank { "/" }
    var mobileNavigationOpen by remember { mutableStateOf(false) }
    val mobileNavigationPresence = rememberLPresence(mobileNavigationOpen, Motion.FastMs)
    // **Navigating closes the drawer.** Its contents are router links, so choosing one swapped the
    // page underneath a full-screen overlay that stayed open, kept its scroll lock, and kept focus
    // trapped inside itself. On a phone that reads as a tap that did nothing — the destination is
    // already rendered, hidden behind the menu the reader must dismiss by hand to discover it.
    LaunchedEffect(currentPath) { mobileNavigationOpen = false }
    Div(AppShellRootStyle.toModifier().toAttrs()) {
        MobileNavigationFrame(
            open = mobileNavigationOpen,
            presence = mobileNavigationPresence,
            triggerId = "$MOBILE_NAVIGATION_TRIGGER_ID-loading",
            onOpenChange = { mobileNavigationOpen = it },
            navigationContent = { SidebarContent(currentPath, roleResolving = true) },
        ) {
            // **The skip link belongs here too, and it was missing.** On a slow connection this is
            // the state that lasts longest, and it was the one state with no way past the rail: the
            // anchor and its `<main>` target existed only in the settled shell, so a keyboard user
            // arriving cold tabbed the whole sidebar before reaching anything. The stylesheet's
            // selector is scoped to a direct child of `[data-app-shell-background]`, which is what
            // this lambda renders into.
            A(
                href = "#$CONTENT_ID",
                attrs = { attr("data-skip-link", "") },
            ) {
                Text(t("app_shell.skip_to_content", "Skip to content"))
            }
            Sidebar(currentPath, roleResolving = true)
            Column(AppMainStyle.toModifier()) {
                Row(
                    // The gutters come from the style, exactly as they do in the settled shell —
                    // they must not disagree between the two or the trail shifts sideways as the
                    // session lands.
                    AppTopBarStyle.toModifier(),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    LSkeleton(
                        modifier = Modifier.displayIfAtLeast(Breakpoint.MD),
                        width = 180.px,
                        height = 16.px,
                        shape = LSkeletonShape.TEXT,
                        label = t("app_shell.loading_session", "Loading session"),
                    )
                    Div(Modifier.flexGrow(1).displayIfAtLeast(Breakpoint.MD).toAttrs())
                    // **Real and disabled, not a skeleton.** The field's shape, stroke and placeholder
                    // are known before the session is; drawing a grey block in its place and then
                    // swapping in a field is a control that appears where a control already was.
                    //
                    // The same ladder the settled bar uses, minus the project rung — no slug is
                    // known while the session is still resolving. One placeholder and no
                    // `shorterPlaceholders` left a phone showing the clipped sentence for the whole
                    // of the loading state, which is the one state where nobody can retype it.
                    //
                    // The sentences are `AppShellChrome`'s, the keys deliberately are not: the
                    // catalogue is namespaced per file, so borrowing `app_shell_chrome.search` here
                    // would make it a shared key, which `extract-strings.mjs` reports as a defect.
                    val loadingSentences = topBarSearchPlaceholders(
                        slug = null,
                        global = t("app_shell.search_or_run_a_command", "Search or run a command"),
                        shortest = t("app_shell.search", "Search"),
                    )
                    LSearchField(
                        value = "",
                        onValueChange = {},
                        // 420, matching `AppShellChrome`'s settled field. At 360 the disabled
                        // stand-in was 60px narrower than the control it stands in for, so the field
                        // jumped wider the moment the session landed — which is exactly the movement
                        // drawing a real field instead of a skeleton was meant to avoid.
                        modifier = Modifier.fillMaxWidth().maxWidth(420.px),
                        label = t("app_shell.global_search", "Global search"),
                        placeholder = loadingSentences.first(),
                        shorterPlaceholders = loadingSentences.drop(1),
                        enabled = false,
                        shortcutHint = null,
                    )
                    Row(
                        Modifier.padding(left = Space.MD).gap(Space.SM),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        // A skeleton is the true final *shape*, not just the true final height: the
                        // toggle is a ControlHeight.MD square with Radius.Control and the account
                        // trigger is a pill.
                        LSkeleton(
                            width = ControlHeight.MD,
                            height = ControlHeight.MD,
                            shape = LSkeletonShape.TEXT,
                            label = t("app_shell.loading_theme_control", "Loading theme control"),
                        )
                        LSkeleton(
                            // 146px, the placeholder's own content width — no token, since nothing
                            // sets an account trigger's width to a fixed number.
                            width = 146.px,
                            height = ControlHeight.MD,
                            shape = LSkeletonShape.CIRCLE,
                            label = t("app_shell.loading_account", "Loading account"),
                        )
                    }
                }
                // The same `<main id="content" tabindex="-1">` the settled shell renders, because a
                // skip link whose target is not there is a tab stop that silently does nothing.
                Main(
                    AppContentStyle.toModifier().toAttrs {
                        id(CONTENT_ID)
                        attr("tabindex", "-1")
                    },
                ) {
                    // One region for the three bars. The chrome's own skeletons above each name a
                    // different thing — session, theme control, account — and are worth hearing
                    // separately; these three stand for one page and were three identical
                    // "Loading content" announcements.
                    Span(LVisuallyHiddenStyle.toModifier().toAttrs { attr("role", "status") }) {
                        Text(t("app_shell.loading_the_page", "Loading the page"))
                    }
                    Column(
                        Modifier.fillMaxWidth().gap(Space.LG).attr("aria-hidden", "true"),
                    ) {
                        LSkeleton(width = 36.percent, height = 28.px, shape = LSkeletonShape.TEXT, label = null)
                        LSkeleton(height = 112.px, label = null)
                        LSkeleton(height = 112.px, label = null)
                    }
                }
            }
        }
    }
}

